import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { ConfigurationUsersScreenBlockCreatePage } from './configuration-users-screen-block-create/configuration-users-screen-block-create';
import { TranslateService } from '@ngx-translate/core';
import { HttpParams, HttpClient } from '@angular/common/http';

/**
 * Generated class for the ConfigurationRoomsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-users-screen-block',
    templateUrl: 'configuration-users-screen-block.html',
})
export class ConfigurationUsersScreenBlockPage {
    pos_screen_block: boolean;
    orders_screen_block: boolean;
    load_users: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public translate: TranslateService,
        private http: HttpClient) {

        this.getAllInfo();
    }

    async getAllInfo() {
        this.load_users = false;
        // Inicializar campos si no existen
        if (this.globals.restaurant.pos_screen_block === undefined) {
            this.globals.restaurant.pos_screen_block = false;
        }
        if (this.globals.restaurant.orders_screen_block === undefined) {
            this.globals.restaurant.orders_screen_block = false;
        }
        this.pos_screen_block = this.globals.restaurant.pos_screen_block;
        this.orders_screen_block = this.globals.restaurant.orders_screen_block;
        this.configurationServices.getUsersScreenBlock(this.globals.restaurant_uid);
        //get users
        const params = new HttpParams()
            .set('uid_restaurant', this.globals.restaurant_uid);
        this.http.post(this.globals.analytics_path + 'users/get_users', params, {})
            .subscribe(res => {
                this.globals.users = res;
                this.load_users = true;
            }, err => {
                this.load_users = true;
            });
    }

    create() {
        this.navCtrl.push(ConfigurationUsersScreenBlockCreatePage, {
            update_state: false,
        });
    }

    edit(user) {
        this.navCtrl.push(ConfigurationUsersScreenBlockCreatePage, {
            update_state: true,
            user: user,
        });
    }

    async updatePosScreenBlock(pos_screen_block_value) {
        this.globals.restaurant.pos_screen_block = pos_screen_block_value;
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'pos_screen_block': pos_screen_block_value,
        });
    }

    async updateOrdersScreenBlock(orders_screen_block_value) {
        this.globals.restaurant.orders_screen_block = orders_screen_block_value;
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'orders_screen_block': orders_screen_block_value,
        });
    }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-users-screen-block/configuration-users-screen-block.ts